import styled from 'styled-components'

export const StyledLoader = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
`

export const StyledLoaderWithBackground = styled(StyledLoader)`
  //TODO: this color is from an old palette, please replace it with a new one
  background: #222222;
`

export const StyledCenterPosition = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
